// The admin-mode switch (standard 8), @jkast90/kast-common/auth's admin
// mode: offered only to the admin group (./adminGroups.ts), on from the
// start (kast-common 2.0: only a stored "false" turns it off, and an
// unreadable storage leaves it on), switched off and on again in Settings,
// kept on this device, and never granting on its own: without the group it
// does nothing. Every useAdmin() shares it, and another tab's change shows
// at once.

import { createAdminMode } from "@jkast90/kast-common/auth";
import { ADMIN_GROUPS } from "./adminGroups";

/** Where the switch is remembered on this device ("true" / "false"). */
export const ADMIN_MODE_KEY = "adminOverride";

export const adminMode = createAdminMode({ admin: ADMIN_GROUPS, storageKey: ADMIN_MODE_KEY });
